<!-- modals -->
<app-recovery></app-recovery>
<app-login-loading></app-login-loading>
<app-login-error></app-login-error>

<!-- <div class="perfil-switch-container">
  <span class="perfil-label">Perfil actual:</span>
  <div class="perfil-switch">
    <div [class.active]="perfil === 'paciente'" (click)="cambiarPerfil('paciente')" style="font-size: 12px;">Paciente</div>
    <div [class.active]="perfil === 'medico'" (click)="cambiarPerfil('medico')" style="font-size: 12px;">Médico</div>
  </div>
</div> -->

<section class="container-fluid m-0 p-0 login-container">
  <!-- ✅ Un solo banner (sin duplicar desktop/mobile) -->

    <!-- Banner (en flujo normal) -->
    <ng-container *ngIf="adsTransversal?.length > 0">
        <div class="top-banner">
            <div class="top-banner-content">
                <div class="top-banner-text">
                {{ adsTransversal[currentIndexTransversal]?.subtitle || adsTransversal[currentIndexTransversal]?.title }}
                </div>

                <div class="top-banner-dots" *ngIf="adsTransversal.length > 1">
                <span
                    class="top-banner-dot"
                    *ngFor="let b of adsTransversal; let i = index"
                    [class.active]="i === currentIndexTransversal"
                    (click)="goToTransversal(i)"
                ></span>
                </div>
                <button type="button" class="top-banner-close" (click)="closeTransversalBanner()">✕</button>
            </div>
        </div>
    </ng-container>

  <div class="login-hero">
    <!-- ✅ Solo 1 descarga de imagen según breakpoint -->
    <picture class="login-hero-media" aria-hidden="true">
      <source media="(max-width: 575.98px)" srcset="assets/images/medis-login-doctor-mobile.jpg" />
      <img
        src="assets/images/medis-login-doctor.jpg"
        alt=""
        loading="eager"
        decoding="async"
      />
    </picture>

    <!-- Contenido sobre la imagen -->
    <div class="login-hero-content">
      <div class="login-panel">
        <div class="m-0 p-0 login-logo text-center">
          <img src="assets/images/logo-almamedis.png" alt="alamedis logo">
        </div>

        <!-- ✅ Un solo login (responsivo por CSS) -->
        <app-login [loginPaciente]="false" [loginMobile]="false"></app-login>
      </div>
    </div>

    <!-- Curva (una sola vez) -->
    <svg class="curve" data-name="Layer 1" viewBox="0 0 1440 122" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M1439 180.5H0V0C149 7 463.385 28.1203 768 86.5C1031.5 137 1323.33 64.1667 1439 20.5L1439 180.5Z"
      />
    </svg>
  </div>

  <!-- Mensaje -->
  <!--
  <div class="row login-message m-0">
    <div class="col-12">
      <p>
        La más completa comunidad de salud en <span class="highlight">cualquier lugar</span>
        y cuando <span class="highlight">nos necesites</span>
      </p>
    </div>
  </div>
  -->

  <!-- Skills -->
   <!--
  <div class="row login-skills justify-content-center align-items-stretch m-0">
    <div class="col-12 col-sm-6 col-lg-4 p-2">
      <div class="skill-wrapper">
        <img src="assets/images/icon/healthcare.svg" alt="icono healthcare">
        <p class="mt-4">Una plataforma cercana y que te acompaña</p>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-lg-4 p-2">
      <div class="skill-wrapper">
        <img src="assets/images/icon/mobile-phone.svg" alt="icono mobile">
        <p class="mt-4">Constantemente conectados con nuestros pacientes</p>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-lg-4 p-2">
      <div class="skill-wrapper">
        <img class="align-self-center" src="assets/images/icon/protection.svg" alt="icono seguridad">
        <p class="mt-4">Todos tus datos protegidos con altos estándares de seguridad</p>
      </div>
    </div>
  </div>
  -->

  <!--
  <app-login-footer></app-login-footer>
  -->
</section>
